var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener, SelectItemEventListener, UnselectItemEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class CardListAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onAddNewClick = new ClickEventListener(); // TODO maybe an interface
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
        /** @event */
        this.onSelectItem = new SelectItemEventListener();
        /** @event */
        this.onUnselectItem = new UnselectItemEventListener();
    }
    /**
     * Returns the data being used to populate the card list.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Sets the data that is used to populate the card list.
     *
     * @param data - The card list data.
     */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Returns if the card is loading.
     */
    isLoading() {
        return this.state.loading;
    }
    /**
     * Sets if the card should be loading.
     *
     * @param loading - If the card is loading.
     */
    setLoading(loading) {
        this.setState({ loading });
    }
    /**
     * Returns the number of placeholder cards that are being rendered.
     */
    getPlaceholderCount() {
        return this.state.placeholderCount;
    }
    /**
     * Sets the number of placeholder cards that should be rendered.
     *
     * @param placeholderCount - Number of placeholder cards that should be rendered.
     */
    setPlaceholderCount(placeholderCount) {
        this.setState({ placeholderCount });
    }
    /**
     * Returns if the "Add new" button is visible.
     */
    isShowAddNew() {
        return this.state.showAddNew;
    }
    /**
     * Sets if the "Add new" button should be visible.
     *
     * @param showAddNew - If the "Add new" button should be visible.
     */
    setShowAddNew(showAddNew) {
        this.setState({ showAddNew });
    }
    /**
     * Returns if the dates are visible.
     */
    isShowDates() {
        return this.state.showDates;
    }
    /**
     * Sets if the dates should be visible.
     *
     * @param showDates - If the dates should be visible.
     */
    setShowDates(showDates) {
        this.setState({ showDates });
    }
    /**
     * Returns the current class name of the "Add new" button.
     */
    getAddNewClassName() {
        return this.state.addNewClassName;
    }
    /**
     * Sets the class name of the "Add new" button.
     *
     * @param addNewClassName - The new class name of the "Add new" button.
     */
    setAddNewClassName(addNewClassName) {
        this.setState({ addNewClassName });
    }
    /**
     * Returns the current expression of the "Add new" button.
     */
    getAddNewExpression() {
        return this.state.addNewExpression;
    }
    /**
     * Sets the expression of the "Add new" button.
     *
     * @param addNewClassName - The new expression of the "Add new" button.
     */
    setAddNewExpression(addNewExpression) {
        this.setState({ addNewExpression });
    }
    /**
     * Returns the current subtitle expression for an empty card list.
     */
    getEmptyResultSubtitleExpression() {
        return this.state.emptyResultSubtitleExpression;
    }
    /**
     * Sets the subtitle expression for an empty card list.
     *
     * @param emptyResultSubtitleExpression - The new subtitle expression for an empty card list.
     */
    setEmptyResultSubtitleExpression(emptyResultSubtitleExpression) {
        this.setState({ emptyResultSubtitleExpression });
    }
    /**
     * Returns the current title expression for an empty card list.
     */
    getEmptyResultTitleExpression() {
        return this.state.emptyResultTitleExpression;
    }
    /**
     * Sets the title expression for an empty card list.
     *
     * @param emptyResultTitleExpression - The new title expression for an empty card list.
     */
    setEmptyResultTitleExpression(emptyResultTitleExpression) {
        this.setState({ emptyResultTitleExpression });
    }
    /**
     * Returns the current selected cards ids.
     */
    getSelectedCards() {
        return this.state.selectedCards;
    }
    /**
     * Sets the selected cards.
     *
     * @param selectedCards - Array of card ids to be selected.
     */
    setSelectedCards(selectedCards) {
        this.setState({ selectedCards });
    }
    /**
     * Returns the current selection type.
     */
    getSelectionType() {
        return this.state.selectionType;
    }
    /**
     * Sets the selection type.
     *
     * @param selectionType - The new selection type.
     */
    setSelectionType(selectionType) {
        this.setState({ selectionType });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardListAPI.prototype, "onAddNewClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardListAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardListAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardListAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardListAPI.prototype, "onSelectItem", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardListAPI.prototype, "onUnselectItem", void 0);
export { CardListAPI, };
//# sourceMappingURL=card-list-api.js.map